module.exports = __webpack_public_path__ + "static/media/face_smile.7338f0f2.svg";